import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconProfile = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "silver",
		d: "M10 1.667C5.4 1.667 1.667 5.4 1.667 10S5.4 18.333 10 18.333 18.333 14.6 18.333 10 14.6 1.667 10 1.667zm0 2.5c1.383 0 2.5 1.116 2.5 2.5 0 1.383-1.117 2.5-2.5 2.5s-2.5-1.117-2.5-2.5c0-1.384 1.117-2.5 2.5-2.5zM10 16c-2.083 0-3.925-1.067-5-2.683.025-1.659 3.333-2.567 5-2.567 1.658 0 4.975.908 5 2.567C13.925 14.933 12.083 16 10 16z"
	})
});
export default SvgIconProfile;
